// generated code from src/web-component/dynamic-select.element.html
var stdin_default = '<div class="container"> <span class="input"></span> <dialog class="dropdown" popover=""> <div class="filters"> <input class="search-input"> </div> <ul class="value-list"></ul> <div class="buttons"> <button class="ok">OK</button> <button class="cancel">Cancel</button> </div> </dialog> <div class="dynamic-options"></div>\n</div>\n';
export {
  stdin_default as default
};
